(function () {
  const THRESHOLD = 4000; // $40 in cents
  let barTimeout;
  let lastPercent = 0;

  function applyWidthSafely(bar, percent) {
    bar.style.willChange = 'width';
  bar.style.transition = 'none';
  bar.style.width = percent + '%';

  requestAnimationFrame(() => {
    bar.style.transition = 'width 350ms ease';
  });
}

  function updateBar() {
    const drawer = document.querySelector('cart-drawer-items');
    if (!drawer) return;

    const bar = drawer.querySelector('.free-shipping-progress');
    const text = drawer.querySelector('.free-shipping-text');
    if (!bar || !text) return;

    // updated code
    if (lastPercent > 0) {
      applyWidthSafely(bar, lastPercent);
    }
    // updated code end


    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {

        // updated code
        const percent = Math.min((cart.total_price / THRESHOLD) * 100, 100);
        lastPercent = percent;
        applyWidthSafely(bar, percent);
        // updated code end

        if (cart.total_price >= THRESHOLD) {
          text.textContent = 'Free Shipping on orders over $40';
        } else {
          const remaining = ((THRESHOLD - cart.total_price) / 100).toFixed(2);
          text.textContent = `You're $${remaining} away from FREE shipping`;
        }
      });
  }

  /* Run when cart drawer opens */
  document.addEventListener('click', (e) => {
    if (
      e.target.closest('[href="/cart"]') ||
      e.target.closest('.cart-drawer-toggle') ||
      e.target.closest('button[name="add"]')
    ) {
      setTimeout(updateBar);
    }
  });

  /* Run on quantity change / remove */
  document.body.addEventListener('change', (e) => {
    if (e.target.matches('input[name="updates[]"]')) {
      setTimeout(updateBar);
    }
  });

  document.body.addEventListener('click', (e) => {
    if (e.target.closest('.cart-remove-button') || e.target.closest('.quantity__button')) {
      setTimeout(updateBar);
    }
  });
  
  /* Watch drawer DOM changes (AJAX updates) */

  // updated code
  const observer = new MutationObserver(() => {
  updateBar();
});

  observer.observe(document.body, { childList: true, subtree: true });
  

})(); 